import React, { useEffect, useState } from 'react';
import { deletePropertyService, getAllPropertiesService, getAllpropertyTypesService } from '../../services/propertiesServices';
import { Link } from 'react-router-dom';
import Actions from './additionFields/Actions';
import DataTablePagination from '../../components/Table/DataTablePagination';
import Confirm from '../../utils/Confirm';

const Properties = () => {
    const [forceRequest, setForceRequest] = useState(0);
    const [options, setOptions] = useState([{ value: "", text: "همه" }]);

    const propertiesCols = [
        {
            field: "id",
            text: "#"
        },
        {
            field: "property",
            text: "property"
        },
        {
            field: "slug",
            text: "slug"
        },
        {
            field: "type",
            text: "نوع ويژگي"
        },
        {
            field: null,
            text: "عملیات‌ها",
            element: (rowData) => <Actions rowData={rowData} handleDeleteProperty={handleDeleteProperty} />
        }
    ];

    const handleDeleteProperty = async (propertyData) => {
        const result = await Confirm("تایید عملیات", `آیا از حذف ویژگی "${propertyData.id}" مطمئن هستید؟`, "info", true, "لغو", "بله")
        if (result) {
            try {
                const response = await deletePropertyService(propertyData.id);
                if (response.status === 204) {
                    setForceRequest(prevValue => prevValue + 1);
                }
            } catch (error) {

            }
        }
    }

    const handleGetAllPropertyTypes = async () => {
        try {
            const response = await getAllpropertyTypesService();
            if(response.status === 200) {
                const typeOptions = response.data.map(t => ({
                    value: t.type,
                    text: t.type
                }));
                setOptions(prevValue => [...prevValue, ...typeOptions]);
            }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        handleGetAllPropertyTypes();
    }, []);

    return (
        <DataTablePagination
            tableCols={propertiesCols}
            title="ویژگی‌ها"
            APIFunction={getAllPropertiesService}
            dataField="properties"
            hasOutlet={true}
            searchTitle="property"
            hasCatergory={true}
            categoryOptions={options}
            forceRequest={forceRequest}
        >
            <Link to="/properties/add-property"
                className="bg-primary px-3 py-1 rounded-lg 
            text-white">
                افزودن ویژگی
            </Link>
        </DataTablePagination>
    );
}

export default Properties;
